import { render } from "./DashboardDeviceType.vue?vue&type=template&id=04ec4ea7"
import script from "./DashboardDeviceType.vue?vue&type=script&lang=js"
export * from "./DashboardDeviceType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__